import { useEffect } from "react";

/**
 * Overrides body/html overflow-x from "hidden" to "clip" while the component
 * is mounted, so that position:sticky works on descendants. "clip" still
 * prevents horizontal scrollbars but doesn't create a scroll container.
 */
export const useStickyOverflowFix = () => {
  useEffect(() => {
    const prevBodyOverflow = document.body.style.overflowX;
    const prevHtmlOverflow = document.documentElement.style.overflowX;
    document.body.style.overflowX = "clip";
    document.documentElement.style.overflowX = "clip";
    return () => {
      document.body.style.overflowX = prevBodyOverflow;
      document.documentElement.style.overflowX = prevHtmlOverflow;
    };
  }, []);
};
